import cn from 'classnames'
import React from 'react'

import { testPropsEl } from 'utils/test/qaData'

import type { KitIndents } from '../KitTypes'
import { KitSize } from '../KitTypes'
import * as s from './Divider.module.scss'

interface IDividerProps {
  styleType?: 'vertical' | 'horizontal' | 'dash' | 'ghost' | 'slash'
  size?: 'auto' | KitSize
  free?: boolean
  dark?: boolean
  indents?: KitIndents
  fluid?: boolean
}

const Divider: React.FC<IDividerProps> = ({
  styleType = 'horizontal',
  size = KitSize.M,
  indents,
  free,
  dark,
  fluid,
}) => {
  if (styleType === 'slash') {
    return '/'
  }

  return (
    <hr
      {...testPropsEl('divider', {})}
      className={cn(s[styleType], s[size], { [s.free]: free, [s.dark]: dark, [s.fluid]: fluid })}
      style={indents}
    />
  )
}

export default React.memo(Divider)
